export default function BlogFilters({
  categories,
  tags,
  selectedCategories,
  selectedTags,
  onCategoryChange,
  onTagChange
}) {
  const toggleCategory = (category) => {
    if (selectedCategories.includes(category)) {
      onCategoryChange(selectedCategories.filter(c => c !== category))
    } else {
      onCategoryChange([...selectedCategories, category])
    }
  }

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      onTagChange(selectedTags.filter(t => t !== tag))
    } else {
      onTagChange([...selectedTags, tag])
    }
  }

  const clearAll = () => {
    onCategoryChange([])
    onTagChange([])
  }

  const hasFilters = selectedCategories.length > 0 || selectedTags.length > 0

  if (categories.length === 0 && tags.length === 0) {
    return null
  }

  return (
    <div className="blog-filters">
      {categories.length > 0 && (
        <div className="filter-group">
          <span className="filter-label">Categories:</span>
          <div className="filter-pills">
            {categories.map(category => (
              <button
                key={category}
                className={`filter-pill category-pill ${selectedCategories.includes(category) ? 'active' : ''}`}
                onClick={() => toggleCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      )}

      {tags.length > 0 && (
        <div className="filter-group">
          <span className="filter-label">Tags:</span>
          <div className="filter-pills">
            {tags.map(tag => (
              <button
                key={tag}
                className={`filter-pill tag-pill ${selectedTags.includes(tag) ? 'active' : ''}`}
                onClick={() => toggleTag(tag)}
              >
                #{tag}
              </button>
            ))}
          </div>
        </div>
      )}

      {hasFilters && (
        <button className="filter-clear" onClick={clearAll}>
          Clear filters
        </button>
      )}
    </div>
  )
}
